import { EquipmentData } from '@/features/equipments/types/equipments.type'
import { create } from 'zustand'

interface UseWorkflowShowStore {
  init: () => void

  equipment: EquipmentData | undefined
  setEquipment: (equipment: EquipmentData | undefined) => void

  currentEquipmentUsage: number | undefined
  setCurrentEquipmentUsage: (currentEquipmentUsage: number | undefined) => void
}

export const useWorkflowShowStore = create<UseWorkflowShowStore>((set) => ({
  init: () =>
    set({
      equipment: undefined,
    }),

  equipment: undefined,
  setEquipment: (equipment) =>
    set({
      equipment,
    }),

  currentEquipmentUsage: undefined,
  setCurrentEquipmentUsage: (currentEquipmentUsage) =>
    set({
      currentEquipmentUsage,
    }),
}))
